<template>
  <main class="container mx-auto mt-16 mb-10">
    <UtilsDetailTitleLoading v-if="isLoading" />
    <ArticleDetailTitle
      v-else
      :detail-data="contentsData.attributes"
      text-to="Sustainability"
      url="/sustainability"
    />

    <ClientOnly>
      <UtilsDetailContentLoading v-if="isLoading" :is-case-study="false" />
      <ArticleDetailContent v-else :detail-data="contentsData.attributes" />
    </ClientOnly>

    <ArticleDetailRelatedSustainability
      :detail-id="contentsData.id"
      :type-id="contentsData.attributes.sustainability_type.data.id"
    />
  </main>
</template>

<script setup>
import { useGlobalStore } from '~/store/global'

const global = useGlobalStore()
const mainSeo = global.mainSeo
const mainBanner = global.mainBanner

const route = useRoute()
const isLoading = ref(true)

const contentsData = ref({})

const { data, pending } = await useSuitmediaApiData(
  `/api/contents/${route.params.slug}`,
  {
    query: {
      populate: 'image,layout_component,sustainability_type,seo.image,'
    }
  }
)
isLoading.value = pending.value
contentsData.value = data.value.data

useJsonld({
  '@context': 'https://schema.org/',
  '@type': 'Organization',
  name: contentsData.value?.attributes?.seo?.seo_title || 'Suitmedia',
  url: contentsData.value?.attributes?.url || 'suitmedia.com',
  description:
    contentsData.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  image:
    contentsData.value?.attributes?.seo?.image.data?.attributes?.url ||
    contentsData?.value?.attributes?.image?.data?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png'
})
useSeoMeta({
  title: contentsData.value?.attributes?.seo?.seo_title || 'Suitmedia',
  ogTitle: contentsData.value?.attributes?.seo?.seo_title || 'Suitmedia',
  description:
    contentsData.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  ogDescription:
    contentsData.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  ogImage:
    contentsData.value?.attributes?.seo?.image.data?.attributes?.url ||
    contentsData?.value?.attributes?.image?.data?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png',
  ogType: contentsData.value?.attributes?.seo?.open_graph_type,
  twitterTitle: contentsData.value?.attributes?.seo?.seo_title || 'Suitmedia',
  twitterDescription:
    contentsData.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  twitterImage:
    contentsData.value?.attributes?.seo?.image.data?.attributes?.url ||
    contentsData?.value?.attributes?.image?.data?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png'
})
</script>

<style lang="scss" scoped></style>
